import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { DocumentSVG, ResizeSVG, CheckSVG } from '../components/SVGIcons';
import '../styles/Home.css';

function Home() {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <h1 className="hero-title">Master PAN Card Resizing</h1>
              <p className="hero-subtitle">
                Learn the best practices and techniques for resizing and optimizing your PAN card documents. 
                Get expert tips and tricks to ensure perfect document formats every time.
              </p>
              <a 
                href="https://pancardresizer.net" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <Button variant="primary" size="lg" className="cta-button">
                  Go to PAN Card Resizer Tool
                </Button>
              </a>
            </Col>
            <Col lg={6} className="text-center">
              <div className="hero-image">
                <DocumentSVG />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <Container>
          <h2 className="section-title">Why Choose Our Resources?</h2>
          <Row className="g-4">
            <Col md={4}>
              <Card className="feature-card">
                <Card.Body className="text-center">
                  <div className="feature-icon">
                    <ResizeSVG />
                  </div>
                  <Card.Title>Expert Guidance</Card.Title>
                  <Card.Text>
                    Comprehensive guides on resizing PAN cards and other important documents with precision.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="feature-card">
                <Card.Body className="text-center">
                  <div className="feature-icon">
                    <CheckSVG />
                  </div>
                  <Card.Title>Best Practices</Card.Title>
                  <Card.Text>
                    Learn industry standards and best practices for document preparation and optimization.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="feature-card">
                <Card.Body className="text-center">
                  <div className="feature-icon">
                    <DocumentSVG />
                  </div>
                  <Card.Title>Free Resources</Card.Title>
                  <Card.Text>
                    Access our free tools and resources to help you manage and resize your documents easily.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Blog Preview Section */}
      <section className="blog-preview-section">
        <Container>
          <h2 className="section-title">Featured Articles</h2>
          <Row className="g-4">
            <Col md={6} lg={4}>
              <Link to="/blog/resize-tips" className="blog-card-link">
                <Card className="blog-preview-card">
                  <Card.Body>
                    <h5>Professional Resize Tips</h5>
                    <p>Master the art of resizing PAN cards with our comprehensive guide covering all essential techniques and tools.</p>
                    <span className="read-more">Read More →</span>
                  </Card.Body>
                </Card>
              </Link>
            </Col>
            <Col md={6} lg={4}>
              <Link to="/blog/document-guide" className="blog-card-link">
                <Card className="blog-preview-card">
                  <Card.Body>
                    <h5>Document Size Guide</h5>
                    <p>Understand document dimensions, file sizes, and format requirements for PAN cards and other identification documents.</p>
                    <span className="read-more">Read More →</span>
                  </Card.Body>
                </Card>
              </Link>
            </Col>
            <Col md={6} lg={4}>
              <Link to="/blog/best-practices" className="blog-card-link">
                <Card className="blog-preview-card">
                  <Card.Body>
                    <h5>Best Practices Guide</h5>
                    <p>Learn the dos and don'ts of document management, including quality preservation and format optimization tips.</p>
                    <span className="read-more">Read More →</span>
                  </Card.Body>
                </Card>
              </Link>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h2>Ready to Resize Your PAN Card?</h2>
              <p>
                Use our professional PAN Card Resizer tool to optimize your documents instantly. 
                Fast, secure, and completely free!
              </p>
             
                <Button variant="light" size="lg" className="cta-button-light">
                  Access PAN Card Resizer Now
                </Button>
             
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default Home;
